import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EnumCodigosTwTcAcciones } from '../../_importacion/solicitudes/types/enum';
import { AccessSolicitudExCpeGuard, AccessProductoExCpeGuard, ActionEstadoExCpeGuard, AccessDocumentosExCpeGuard } from './_classes/access.guard';
import { AnulacionCpeEditComponent } from './anulacion/anulacionCpe-edit.component';
import { CertificacionEditComponent } from './certificacion/certificacion-edit.component';
import { CpeEditComponent } from './datosbasicos/cpe-edit.component';
import { DocumentosCpeEditComponent } from './documentos/documentosCpe-edit.component';
import { DocumentosCpeListComponent } from './documentos/documentosCpe-list.component';
import { EnvioCpeEditComponent } from './envio/envioCpe-edit.component';
import { LugarProduccionComponent } from './lugarproduccion/lugarproduccion.component';
import { ProductoCpeEditComponent } from './productos/productosCpe-edit.component';
import { ProductosCpeListComponent } from './productos/productosCpe-list.component';
import { TipoSolicitudCpeListComponent } from './tipossolicitudes/tiposolicitudCpe-list.component';
import { LoginGuard, ActionGuard } from '../../core/_infrastructure/classes/guards/main.guard';

const cpeRoutes: Routes = [
    {
        path: 'exportacion/cpe',
        data: {
            breadcrumb: 'CPEs',
            menu0: 'EXPORTACIÓN',
            //menu1: 'Solicitudes'//,//,
            //,
            overridePath: 'exportacion/cpes',
        },
        children: [
            { path: '', redirectTo: 'tipossolicitudesCpe', pathMatch: 'full' },
            {
                path: 'tipossolicitudesCpe',
                component: TipoSolicitudCpeListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Tipo Solicitud',
                    actionCode: EnumCodigosTwTcAcciones.NUEVA_SOLICITUD_CPE,
                },
            },
            {
                path: 'datosbasicos/create',
                data: {
                    breadcrumb: 'Nueva',
                },
                children: [
                    {
                        path: '',
                        component: CpeEditComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.NUEVA_SOLICITUD_CPE,
                        },
                    },
                ],
            },
            {
                path: 'datosbasicos/:id',
                data: {
                    breadcrumb: 'Datos Básicos',
                },
                children: [
                    {
                        path: '',
                        component: CpeEditComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessSolicitudExCpeGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_BASICOS_CPE,
                        },
                    },
                ],
            },

            //MENU PRODUCTOS
            {
                path: 'productos/:id',
                data: {
                    breadcrumb: 'Productos',
                },
                children: [
                    {
                        path: '',
                        component: ProductosCpeListComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessSolicitudExCpeGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MENU_PRODUCTOS_CPE,
                        },
                    },
                    {
                        path: 'create',
                        component: ProductoCpeEditComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessSolicitudExCpeGuard()],
                        data: {
                            breadcrumb: 'Nuevo',
                            actionCode: EnumCodigosTwTcAcciones.NUEVA_SOLICITUD_CPE,
                        },
                    },
                    {
                        path: 'producto/:idprod',
                        component: ProductoCpeEditComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessProductoExCpeGuard()],
                        data: {
                            breadcrumb: 'Editar Producto',
                            actionCode: EnumCodigosTwTcAcciones.MENU_PRODUCTOS_CPE,
                        },
                    },
                ],
            },

            //LUGAR PRODUCCIÓN
            {
                path: 'lugarproduccion/:id',
                component: LugarProduccionComponent,
                canActivate: [LoginGuard(), ActionEstadoExCpeGuard(), AccessSolicitudExCpeGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_LUGAR_PRODUCCION_CPE,
                    menu0: 'Lugar de Producción',
                },
            },

            //DOCUMENTOS
            {
                path: 'documentos/:id',
                data: {
                    breadcrumb: 'Documentos',
                },
                children: [
                    {
                        path: '',
                        component: DocumentosCpeListComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessSolicitudExCpeGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MENU_DOCUMENTOS_CPE,
                        },
                    },
                    {
                        path: 'create',
                        component: DocumentosCpeEditComponent,
                        //canActivate: [LoginGuard()],//pendiente accion
                        canActivate: [LoginGuard(), ActionEstadoExCpeGuard(), AccessSolicitudExCpeGuard()],
                        data: {
                            breadcrumb: 'Nuevo',
                            actionCode: EnumCodigosTwTcAcciones.GUARDAR_DOCUMENTOS_CPE,
                        },
                    },
                    {
                        path: 'detalleDocumento/:idDocumento',
                        component: DocumentosCpeEditComponent,
                        //canActivate: [LoginGuard(), AccessDocumentosGuard],
                        canActivate: [LoginGuard(), ActionGuard(), AccessDocumentosExCpeGuard()],
                        data: {
                            breadcrumb: 'Detalle Documento',
                            actionCode: EnumCodigosTwTcAcciones.MENU_DOCUMENTOS_CPE,
                        },
                    },
                ],
            },

            //CERTIFICACION
            {
                path: 'certificacion/:id',
                component: CertificacionEditComponent,
                canActivate: [LoginGuard(), ActionEstadoExCpeGuard(), AccessSolicitudExCpeGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_CERTIFICACION_CPE,
                    menu0: 'Certificación',
                },
            },

            //ANULACION
            {
                path: 'anulacion/:id',
                component: AnulacionCpeEditComponent,
                canActivate: [LoginGuard(), ActionEstadoExCpeGuard(), AccessSolicitudExCpeGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_ANULACION_CPE,
                    menu0: 'Anulación',
                },
            },

            //ENVIO
            {
                path: 'envio/:id',
                component: EnvioCpeEditComponent,
                canActivate: [LoginGuard(), ActionEstadoExCpeGuard(), AccessSolicitudExCpeGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_ENVIO_CPE,
                    menu0: 'Envío',
                },
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(cpeRoutes)],
    exports: [RouterModule],
})
export class CpeRoutingModule {}
